import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import '@styles/public/shared/modalWindow.scss';
import { Carousel } from '@components/public/shared/Carousel';

export class ModalWindow extends Component {
    static displayName = ModalWindow.name;

    constructor(props) {
        super(props);

        this.content = Array.isArray(this.props.content) ? this.props.content : [this.props.content];
        this.defaultIndex = this.content.findIndex(c => c.props.src == this.props.default.props.src && c.props.alt == this.props.default.props.alt);
        this.defaultIndex = this.defaultIndex == -1 ? 0 : this.defaultIndex;
        this.default = this.content[this.defaultIndex]; 

        this.state = {
            opened: false,
            isImageSlideShow: this.props.isImageSlideShow ?? true
        }
    }

    HandleClose = () => {
        document.body.classList.remove('noScroll');
        this.setState((prevState) => ({
            ...prevState,
            opened: false
        }));
    }

    HandleOpen = () => {
        document.body.classList.add('noScroll');
        this.setState((prevState) => ({
            ...prevState,
            opened: true
        }));
    }

    EmptyFunction = () => { }

    OnOpenedContentClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
    }

    RenderModal = (content) => {
        return <div className="customModal noSelect  d-flex justify-content-center align-items-center">
            <div className="content" onClick={(e) => this.OnOpenedContentClick(e)}>
                {content}
            </div>
        </div>
    }

    RenderCarousel = () => {
        let modals = this.content.map(c => ({
            element: this.RenderModal(c),
            duration: null
        }));

        return <Carousel
            slides={modals}
            autoPlay={false}
            autoPlayVisible={false}
            currentSlide={this.defaultIndex}
        />
    }

    RenderOpened = () => {

        let modal = <div
            role="button"
            className='modalWindow'
            onClick={() => this.HandleClose()}
        >
            {this.RenderCarousel()}

            <div className="closeButton position-absolute top-0 end-0 m-3 m-md-4">
                <i className="fa-solid fa-x"></i>
            </div>
        </div>

        return ReactDOM.createPortal(
            modal,
            document.body
        );
    }

    RenderDefault = () => {
        return <div role="button" onClick={() => this.HandleOpen()}>
            {this.default}
        </div>
    }

    render() {
        return <>
            {this.RenderDefault()}
            {this.state.opened &&
                this.RenderOpened()
            }            
        </>        
    }
}
